import React, { useState } from 'react';

// The credential fields, shared by the /admin page and the re-authentication
// modal so the two cannot drift apart.
function LoginForm({ onSubmit, error, onCancel, autoFocus = false }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoggingIn(true);
    await onSubmit(username, password);
    setIsLoggingIn(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="admin-username" className="block text-wine font-bold mb-2">Username</label>
        <input
          id="admin-username"
          name="username"
          type="text"
          autoComplete="username"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          className="w-full p-3 border border-gray-300 rounded-lg"
          style={{ borderColor: '#722f37' }}
          required
          disabled={isLoggingIn}
        />
      </div>

      <div>
        <label htmlFor="admin-password" className="block text-wine font-bold mb-2">Password</label>
        <input
          id="admin-password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          className="w-full p-3 border border-gray-300 rounded-lg"
          style={{ borderColor: '#722f37' }}
          required
          disabled={isLoggingIn}
        />
      </div>

      <div role="alert" aria-live="polite">
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
        )}
      </div>

      <div className={`flex ${onCancel ? 'justify-end' : ''} space-x-3 pt-2`}>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-3 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg transition"
            disabled={isLoggingIn}
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          className={`${onCancel ? '' : 'w-full'} px-6 py-3 text-white rounded-lg transition`}
          style={{ backgroundColor: '#722f37', border: '2px solid #f4bc57' }}
          disabled={isLoggingIn}
        >
          {isLoggingIn ? 'Logging in...' : 'Log In'}
        </button>
      </div>
    </form>
  );
}

export default LoginForm;
